import {
  Box,
  Container,
  Text,
  // eslint-disable-next-line no-restricted-imports
  Button,
  FlexProps,
} from '@chakra-ui/react';
import { Header } from '../../atoms/Header';
import Blocks from '../../../assets/blocks.png';
import { useContactModal } from 'src/hooks/useContactModal';
import { ContactModal } from 'src/components/molecules/ContactModal';
import { GlassSheenImage } from '../../molecules/GlassSheenImage';

export const SubHeader: React.FC<FlexProps> = () => {
  const { onOpen, modalProps } = useContactModal({
    defaultInterest: 'pricing',
    title: 'Start Modeling',
    submitButtonText: 'Start Modeling',
  });

  return (
    <>
      <Box
        bg="text.darkBlue.900"
        color="white"
        justifyContent="center"
        display="flex"
        pt={{ base: 8, md: 16 }}
        flexDir="column"
        alignItems="center">
        <Container maxW="container.xl" textAlign="left">
          <Header>
            FROM NOISE TO DECISIONS
            <Text
              fontFamily="marketingPage"
              fontSize={{ base: 'md', md: 'lg' }}
              mt={4}
              fontWeight="medium"
              maxW="3xl"
              textTransform="none">
              AI-powered marketing intelligence that cuts through data chaos and
              delivers clear, actionable media and budget insights — fast.
            </Text>
          </Header>
          <Button
            onClick={onOpen}
            size="lg"
            bg={'icon.green'}
            color="white"
            fontFamily="marketingPage"
            borderRadius={8}
            mb={{ base: 12 }}
            px={8}
            py={4}>
            Start Modeling
          </Button>
          <GlassSheenImage
            src={Blocks}
            alt="3D green glass shapes"
            width="100%"
            objectFit="cover"
          />
        </Container>
      </Box>
      <ContactModal {...modalProps} />
    </>
  );
};
